import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, inject, type OnInit } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router, RouterModule } from '@angular/router';
import { UserService } from '@core/services/user.service';
import { PrimeNgSettings } from '@core/static/primeng.static';
import { MessageService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { InputTextModule } from 'primeng/inputtext';
import { finalize } from 'rxjs';

@Component({
  selector: 'tr-forgot',
  imports: [
    CommonModule,
    ButtonModule,
    InputTextModule,
    InputIconModule,
    IconFieldModule,
    ReactiveFormsModule,
    RouterModule,
  ],
  templateUrl: './Forgot.component.html',
  styleUrl: './Forgot.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ForgotComponent implements OnInit {
  private router = inject(Router);
  private messageService = inject(MessageService);
  private cdr = inject(ChangeDetectorRef);
  private userService = inject(UserService);

  forgotForm: FormGroup;
  submitting: boolean = false;

  constructor() {
    this.forgotForm = new FormGroup({
      email: new FormControl('', [Validators.required, Validators.email]),
    });
  }

  ngOnInit(): void {}

  onSubmit() {
    this.forgotForm.markAllAsTouched();

    if (this.forgotForm.valid) {
      this.submitting = true;

      this.userService
        .forgot(this.forgotForm.value.email)
        .pipe(
          finalize(() => {
            this.submitting = false;
            this.cdr.detectChanges();
          })
        )
        .subscribe({
          next: (user) => {
            this.messageService.add({
              severity: 'success',
              key: 'main-toast',
              summary: 'Password reset sent',
              detail: 'Your password reset email has been sent, please check for it in your email.',
              life: PrimeNgSettings.MessageLife,
            });

            this.router.navigate(['/login']);
          },
          error: () => {
            this.messageService.add({
              severity: 'warn',
              key: 'main-toast',
              summary: 'Failed',
              detail: 'Sorry, password reset failed, please try again.',
              life: PrimeNgSettings.MessageLife,
            });
          },
        });
    }
  }
}
